import Vue from 'vue';
import { Pagination, A11y, Keyboard } from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    },
    el,
    data: () => ({
      swiperOptions: {
        slidesPerView: 1.1,
        spaceBetween: 5,
        centeredSlides: true,
        a11y: true,
        keyboard: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return `<button class="${className}"></button>`;
          },
        },
        modules: [Pagination, A11y, Keyboard]
      },
    }),
    mounted() {},
    methods: {},
  });
